export const TIME_BETWEEN_STEPS = 3;
export const getAnimationNumber = ({
  isFree,
  hasADate,
}: { isFree: true; hasADate: boolean } | { isFree: false; hasADate?: boolean }) => {
  return isFree && !hasADate ? 1 : isFree ? 2 : 3;
};
